import type { UUID } from "./uuid";

const ALPHABET = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
const BASE = BigInt(ALPHABET.length);
const SHORT_ID_LENGTH = 12;
const BIT_MASK = (1n << 71n) - 1n;

function toBase62(num: bigint, length: number = SHORT_ID_LENGTH): string {
  let value = num;
  let encoded = "";

  while (value > 0n) {
    const remainder = value % BASE;
    encoded = ALPHABET[Number(remainder)] + encoded;
    value /= BASE;
  }

  return encoded.padStart(length, ALPHABET[0]);
}

async function sha256(input: UUID): Promise<Uint8Array> {
  const data = new TextEncoder().encode(input);
  const buffer = await crypto.subtle.digest("SHA-256", data);
  return new Uint8Array(buffer);
}

export async function uuidToShortId(uuid: UUID): Promise<string> {
  const hash = await sha256(uuid);

  const view = new DataView(hash.buffer, hash.byteOffset, hash.byteLength);
  const high = view.getBigUint64(0);
  const low = BigInt(hash[8]!);
  let value = (high << 8n) | low;
  value &= BIT_MASK;

  return toBase62(value, SHORT_ID_LENGTH);
}
